import {WlChip} from "./chip.component";

export * from './chip.component';
export default WlChip;

customElements.define('wl-chip', WlChip);
